import http, { BATCH_TIMEOUT } from "../http";

/** Endpoints de Meli Flex. Contrato en meli-flex-front.md §5. Las variantes en lote NO fallan en bloque: cada item trae su `success`. */

// --- Configuracion -----------------------------------------------------------

export const getFlexConfig = () => http.get("api/meli-flex/config");

export const updateFlexConfig = (payload) => http.put("api/meli-flex/config", payload);

// --- Envios ------------------------------------------------------------------

/** Despacho directo, de un solo paso: en Flex NO hay cotizacion previa. */
export const createFlexShipment = (meliOrderId) =>
  http.post(`api/flex-create-shipment/${meliOrderId}`);

/** Lote. El backend valida un maximo (CDS_FLEX_CREATE_SHIPMENTS_MAX, default 30). */
export const createFlexShipments = (meliOrderIds) =>
  http.post("api/flex-create-shipments", { meli_order_ids: meliOrderIds }, { timeout: BATCH_TIMEOUT });

/** Anula el envio en CDS. OJO: la orden vuelve a "Por enviar", NO se descarta. Sin body y sin version en lote. */
export const cancelFlexShipment = (meliOrderId) =>
  http.post(`api/flex-cancel-shipment/${meliOrderId}`);

// --- Etiquetas ---------------------------------------------------------------
// Devuelven PDF binario, pero ante un error responden JSON, que con responseType blob llega como Blob igual.

export const downloadFlexLabel = (meliShipmentId) =>
  http.get(`api/flex-label/${meliShipmentId}`, { responseType: "blob" });

/** Lote. Un unico PDF. Maximo del backend: MELI_SHIPMENT_LABELS_MAX (default 30). */
export const downloadFlexLabels = (meliShipmentIds) =>
  http.post(
    "api/flex-labels",
    { meli_shipment_ids: meliShipmentIds },
    { responseType: "blob", timeout: BATCH_TIMEOUT }
  );

/** Dispara la descarga en el navegador. */
export const saveBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/** Lee el mensaje de un error que vino como Blob. FileReader en vez de Blob.text(), que no existe en navegadores viejos. */
export const readBlobError = (error) =>
  new Promise((resolve) => {
    const data = error && error.response && error.response.data;
    if (!(data instanceof Blob)) return resolve(null);

    const reader = new FileReader();
    reader.onload = () => {
      try {
        const json = JSON.parse(reader.result);
        if (json.message) return resolve(json.message);
        if (json.errors) {
          const first = Object.values(json.errors)[0];
          if (Array.isArray(first) && first.length) return resolve(first[0]);
        }
        resolve(null);
      } catch (e) {
        resolve(null);
      }
    };
    reader.onerror = () => resolve(null);
    reader.readAsText(data);
  });

/** Normaliza { summary, results } del lote a algo que la UI pueda listar. */
export const normalizeBatchResult = (data) => {
  const results = (data && data.results) || [];
  return {
    summary: (data && data.summary) || {
      total: results.length,
      succeeded: results.filter((r) => r.success).length,
      failed: results.filter((r) => !r.success).length,
    },
    succeeded: results.filter((r) => r.success),
    failed: results.filter((r) => !r.success),
  };
};
